export const messageSubmissionSuccessful = (agentName:string) => {
  const theAgent = !agentName.trim() ? "The agent" : agentName

  return `Form submitted successfully! ${theAgent} will contact you soon.`
}

export const DURATION_NOTIFICATION = {
  SHORT: 2000
}

